import React from 'react';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import { Globe, ArrowLeft } from 'lucide-react';
import { LogoIcon } from './Logo';
import MiniCart from './MiniCart';
import MiniFavorites from './MiniFavorites';

const Header = () => {
  const { country } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const handleCountryChange = () => {
    navigate('/');
  };

  const handleBack = () => {
    navigate(-1);
  };

  const getCountryLabel = (code) => {
    const labels = {
      'br': 'Brasil',
      'us': 'USA',
      'eu': 'Europe',
      'uk': 'UK'
    };
    return labels[code] || 'Select Country';
  };

  const getMenuItems = () => {
    const menuByCountry = {
      'br': [
        { label: 'Home', path: `/${country}` },
        { label: 'CRM', path: `/${country}/crm` },
        { label: 'IA', path: `/${country}/ai` },
        { label: 'Serviços', path: `/${country}/services` },
        { label: 'Produtos', path: `/${country}/products` }
      ],
      'us': [
        { label: 'Home', path: `/${country}` },
        { label: 'CRM', path: `/${country}/crm` },
        { label: 'AI', path: `/${country}/ai` },
        { label: 'Services', path: `/${country}/services` },
        { label: 'Products', path: `/${country}/products` }
      ],
      'eu': [
        { label: 'Home', path: `/${country}` },
        { label: 'CRM', path: `/${country}/crm` },
        { label: 'AI', path: `/${country}/ai` },
        { label: 'Services', path: `/${country}/services` },
        { label: 'Products', path: `/${country}/products` }
      ],
      'uk': [
        { label: 'Home', path: `/${country}` },
        { label: 'CRM', path: `/${country}/crm` },
        { label: 'AI', path: `/${country}/ai` },
        { label: 'Services', path: `/${country}/services` },
        { label: 'Products', path: `/${country}/products` }
      ]
    };
    return menuByCountry[country] || menuByCountry['br'];
  };

  const menuItems = country ? getMenuItems() : [];

  // Verificar se está na landing page
  const isLandingPage = location.pathname === '/';

  return (
    <header className="fixed top-0 left-0 right-0 bg-white border-b border-aug-gray-light shadow-sm z-50">
      <div className="max-w-[1400px] mx-auto px-xl py-md flex items-center justify-between gap-4">
        {/* Botão Voltar + Logo */}
        <div className="flex items-center gap-4">
          {!isLandingPage && (
            <button
              onClick={handleBack}
              className="flex items-center gap-2 px-3 py-2 hover:bg-aug-cream rounded-lg transition-all duration-300 text-aug-gray-dark"
              data-testid="back-button"
            >
              <ArrowLeft className="w-5 h-5" style={{ color: '#1B5E20' }} />
              <span className="text-sm font-medium hidden md:block">Voltar</span>
            </button>
          )}
          
          <Link to={country ? `/${country}` : '/'} className="flex items-center space-x-3">
            <LogoIcon size={48} />
            <span className="font-bold text-xl hidden lg:block">
              <span style={{ color: '#1B5E20' }}>AGRO URBAN </span>
              <span style={{ color: '#F9A825' }}>GLOBAL</span>
            </span>
          </Link>
        </div>

        {/* Menu de Navegação */}
        {country && (
          <nav className="hidden lg:flex items-center gap-6">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium transition-all duration-300 hover:text-aug-blue ${
                  location.pathname === item.path
                    ? 'text-aug-blue border-b-2 border-aug-blue pb-1'
                    : 'text-aug-gray-dark'
                }`}
                style={location.pathname === item.path ? { color: '#1B5E20' } : {}}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        )}

        {/* Seletor de País + Seja Parceiro + Favoritos + MiniCart */}
        <div className="flex items-center gap-3">
          {country && (
            <Link
              to="/parceiro/login"
              className="hidden md:flex items-center gap-1.5 px-4 py-2 text-sm font-semibold text-white rounded-lg transition-all duration-300 hover:opacity-90"
              style={{ background: 'linear-gradient(135deg, #1B5E20, #2E7D32)' }}
              data-testid="become-partner-btn"
            >
              Seja Parceiro
            </Link>
          )}

          {country && (
            <button
              onClick={handleCountryChange}
              className="flex items-center space-x-2 px-3 py-2 bg-aug-cream hover:bg-aug-salmon rounded-lg transition-all duration-300"
              data-testid="change-country-btn"
            >
              <Globe className="w-4 h-4" style={{ color: '#1B5E20' }} />
              <span className="text-sm font-medium text-aug-gray-dark hidden md:block">
                {getCountryLabel(country)}
              </span>
            </button>
          )}
          
          {country && <MiniFavorites />}
          {country && <MiniCart />}
        </div>
      </div>
    </header>
  );
};

export default Header;
